import { render, staticRenderFns } from "./riskItem.vue?vue&type=template&id=0a5756af&scoped=true&"
import script from "./riskItem.vue?vue&type=script&lang=js&"
export * from "./riskItem.vue?vue&type=script&lang=js&"
import style0 from "./riskItem.vue?vue&type=style&index=0&id=0a5756af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5756af",
  null
  
)

export default component.exports